import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'relay-runtime';

export const agentSessionEventsSubscription: GraphQLTaggedNode = graphql`
	subscription agentSessionEventsSubscription(
		$accountId: String!
		$cloudId: ID!
		$workspaceAri: ID!
	) {
		convoai_onInboxSessionChanged(
			accountId: $accountId
			cloudId: $cloudId
			workspaceAri: $workspaceAri
		) @optIn(to: "ConvoAiInboxSessionChanged") {
			sessionId
			sessionAri
			session {
				__typename
				hasUnseenActivity
				invocationType
				...agentSessionCore_session @relay(mask: false)
			}
		}
	}
`;
